var Ie=(t,e,a)=>{if(!e.has(t))throw TypeError("Cannot "+a)};var v=(t,e,a)=>(Ie(t,e,"read from private field"),a?a.call(t):e.get(t)),k=(t,e,a)=>{if(e.has(t))throw TypeError("Cannot add the same private member more than once");e instanceof WeakSet?e.add(t):e.set(t,a)},U=(t,e,a,o)=>(Ie(t,e,"write to private field"),o?o.call(t,a):e.set(t,a),a);var f=(t,e,a)=>(Ie(t,e,"access private method"),a);import"@mux/playback-core";import{MediaController as yi}from"media-chrome";import vi,{MediaError as ze}from"@mux/mux-video";import{StreamTypes as P,addTextTrack as ki,removeTextTrack as Ei}from"@mux/playback-core";import{VideoEvents as xa}from"@mux/mux-video";var ga="en",F={code:ga};var at="en";function s(t,e=!0){var i,r;let a=e&&(r=(i=F)==null?void 0:i[t])!=null?r:t,o=e?F.code:at;return new it(a,o)}var it=class{constructor(e,a=(o=>(o=F.code)!=null?o:at)()){this.message=e,this.locale=a}format(e){return this.message.replace(/\{(\w+)\}/g,(a,o)=>{var i;return(i=e[o])!=null?i:""})}toString(){return this.message}};function ot(t){let e="";return Object.entries(t).forEach(([a,o])=>{o!=null&&(e+=`${fa(a)}: ${o}; `)}),e?e.trim():void 0}function fa(t){return t.replace(/([a-z])([A-Z])/g,"$1-$2").toLowerCase()}function rt(t){return t.replace(/[-_]([a-z])/g,(e,a)=>a.toUpperCase())}function K(t){if(t==null)return;let e=+t;return Number.isNaN(e)?void 0:e}function ue(t){let e=ba(t).toString();return e?"?"+e:""}function ba(t){let e={};for(let a in t)t[a]!=null&&(e[a]=t[a]);return new URLSearchParams(e)}function re(t){let a=t.split(".")[1].replace(/-/g,"+").replace(/_/g,"/"),o=decodeURIComponent(atob(a).split("").map(function(i){return"%"+("00"+i.charCodeAt(0).toString(16)).slice(-2)}).join(""));return JSON.parse(o)}var Pe=(t,e)=>!t||!e?!1:t.contains(e)?!0:Pe(t,e.getRootNode().host);import{StreamTypes as pe}from"@mux/playback-core";var _e="mux.com",ya=()=>{try{return"0.1.0-beta.26"}catch{}return"UNKNOWN"},va=ya(),he=()=>va,De=(t,{token:e,domain:a=_e}={})=>`https://stream.${a}/${t}.m3u8${ue(!!e?{token:e}:{redundant_streams:!0})}`,nt=(t,{token:e,thumbnailTime:a,domain:o=_e}={})=>{let i=e==null?a:void 0;return`https://image.${o}/${t}/thumbnail.jpg${ue({token:e,time:i})}`},st=(t,{token:e,domain:a=_e}={})=>`https://image.${a}/${t}/storyboard.vtt${ue({token:e})}`;function Ne(t){if(t&&/^media-theme-[\w-]+$/.test(t))return t}var ka={crossorigin:"crossOrigin",playsinline:"playsInline"};function lt(t){var e;return(e=ka[t])!=null?e:rt(t)}var dt=t=>{var a,o;let{media:e}=t;return(o=(a=e==null?void 0:e._hls)==null?void 0:a.liveSyncPosition)!=null?o:(e==null?void 0:e.seekable.length)?e==null?void 0:e.seekable.end(e.seekable.length-1):void 0},Ve=t=>{let e=dt(t);if(e==null){console.warn("attempting to seek to live but cannot determine live edge time!");return}t.currentTime=e},Ea=1,Ta=5,mt=3,ct=.5,ut=t=>{var r;let{streamType:e}=t,a=dt(t),o=(r=t.media)==null?void 0:r.currentTime;if(a==null||o==null)return!1;let i=a-o;return e===pe.LL_LIVE||e===pe.LL_DVR?i<=Ea*(mt+ct):e===pe.LIVE||e===pe.DVR?i<=Ta*(mt+ct):!1};var pt=`[mux-player ${he()}]`;function w(...t){console.warn(pt,...t)}function D(...t){console.error(pt,...t)}function ge(t){var a;let e=(a=t.message)!=null?a:"";if(t.file){let o="https://github.com/muxinc/elements/blob/main/errors/";e+=` ${s("Read more: ")}
${o}${t.file}`}w(e)}var p={AUTOPLAY:"autoplay",CROSSORIGIN:"crossorigin",LOOP:"loop",MUTED:"muted",PLAYSINLINE:"playsinline",SRC:"src",POSTER:"poster",PRELOAD:"preload"},Y={VOLUME:"volume",PLAYBACKRATE:"playbackrate",MUTED:"muted"},Aa=xa.filter(t=>t!=="error"),wa=Object.values(p),La=Object.values(Y);function ht(t){t.querySelectorAll(":scope > track").forEach(e=>{var a;(a=t.media)==null||a.append(e.cloneNode())}),Aa.forEach(e=>{var a;(a=t.media)==null||a.addEventListener(e,o=>{t.dispatchEvent(new Event(o.type))})})}var gt=class extends HTMLElement{static get observedAttributes(){return[...wa,...La]}constructor(){super();this.querySelectorAll(":scope > track").forEach(o=>{var i;(i=this.media)==null||i.append(o.cloneNode())});let e=o=>{for(let i of o)i.type==="childList"&&(i.removedNodes.forEach(r=>{var m,g;let n=(m=this.media)==null?void 0:m.querySelector(`track[src="${r.src}"]`);n&&((g=this.media)==null||g.removeChild(n))}),i.addedNodes.forEach(r=>{var n;(n=this.media)==null||n.append(r.cloneNode())}))};new MutationObserver(e).observe(this,{childList:!0,subtree:!0})}attributeChangedCallback(e,a,o){switch(e){case Y.MUTED:{this.media&&(this.media.muted=o!=null,this.media.defaultMuted=o!=null);return}case Y.VOLUME:{let i=+o;this.media&&!Number.isNaN(i)&&(this.media.volume=i);return}case Y.PLAYBACKRATE:{let i=+o;this.media&&!Number.isNaN(i)&&(this.media.playbackRate=i,this.media.defaultPlaybackRate=i);return}}}play(){var e;return(e=this.media)==null?void 0:e.play()}pause(){var e;(e=this.media)==null||e.pause()}requestCast(e){var a;return(a=this.media)==null?void 0:a.requestCast(e)}get media(){var e;return(e=this.shadowRoot)==null?void 0:e.querySelector("mux-video")}get video(){return w("<mux-player>.video is deprecated, please use .media instead"),this.media}get paused(){var e,a;return(a=(e=this.media)==null?void 0:e.paused)!=null?a:!0}get duration(){var e,a;return(a=(e=this.media)==null?void 0:e.duration)!=null?a:NaN}get ended(){var e,a;return(a=(e=this.media)==null?void 0:e.ended)!=null?a:!1}get buffered(){var e;return(e=this.media)==null?void 0:e.buffered}get readyState(){var e,a;return(a=(e=this.media)==null?void 0:e.readyState)!=null?a:0}get videoWidth(){var e;return(e=this.media)==null?void 0:e.videoWidth}get videoHeight(){var e;return(e=this.media)==null?void 0:e.videoHeight}get currentTime(){var e,a;return(a=(e=this.media)==null?void 0:e.currentTime)!=null?a:0}set currentTime(e){this.media&&(this.media.currentTime=Number(e))}get volume(){var e,a;return(a=(e=this.media)==null?void 0:e.volume)!=null?a:1}set volume(e){this.media&&(this.media.volume=Number(e))}get src(){return N(this,p.SRC)}set src(e){this.setAttribute(p.SRC,`${e}`)}get poster(){var e;return(e=N(this,p.POSTER))!=null?e:""}set poster(e){this.setAttribute(p.POSTER,`${e}`)}get playbackRate(){var e,a;return(a=(e=this.media)==null?void 0:e.playbackRate)!=null?a:1}set playbackRate(e){this.media&&(this.media.playbackRate=Number(e))}get defaultPlaybackRate(){var e;return(e=K(this.getAttribute(Y.PLAYBACKRATE)))!=null?e:1}set defaultPlaybackRate(e){e!=null?this.setAttribute(Y.PLAYBACKRATE,`${e}`):this.removeAttribute(Y.PLAYBACKRATE)}get crossOrigin(){return N(this,p.CROSSORIGIN)}set crossOrigin(e){this.setAttribute(p.CROSSORIGIN,`${e}`)}get autoplay(){return N(this,p.AUTOPLAY)!=null}set autoplay(e){e?this.setAttribute(p.AUTOPLAY,typeof e=="string"?e:""):this.removeAttribute(p.AUTOPLAY)}get loop(){return N(this,p.LOOP)!=null}set loop(e){e?this.setAttribute(p.LOOP,""):this.removeAttribute(p.LOOP)}get muted(){var e,a;return(a=(e=this.media)==null?void 0:e.muted)!=null?a:!1}set muted(e){this.media&&(this.media.muted=Boolean(e))}get defaultMuted(){return N(this,p.MUTED)!=null}set defaultMuted(e){e?this.setAttribute(p.MUTED,""):this.removeAttribute(p.MUTED)}get playsInline(){return N(this,p.PLAYSINLINE)!=null}set playsInline(e){e?this.setAttribute(p.PLAYSINLINE,""):this.removeAttribute(p.PLAYSINLINE)}get preload(){return N(this,p.PRELOAD)}set preload(e){e?this.setAttribute(p.PRELOAD,e):this.removeAttribute(p.PRELOAD)}};function N(t,e){return t.media?t.media.getAttribute(e):t.getAttribute(e)}var Be=gt;import{MediaTheme as ei}from"media-chrome";import{TemplateInstance as ft,NodeTemplatePart as fe,createProcessor as Sa,AttributeTemplatePart as He}from"@github/template-parts";var ne=new WeakMap,be=class{constructor(e,a){this.element=e;this.type=a;this.element.addEventListener(this.type,this);let o=ne.get(this.element);o&&o.set(this.type,this)}set(e){if(typeof e=="function")this.handleEvent=e.bind(this.element);else if(typeof e=="object"&&typeof e.handleEvent=="function")this.handleEvent=e.handleEvent.bind(e);else{this.element.removeEventListener(this.type,this);let a=ne.get(this.element);a&&a.delete(this.type)}}static for(e){ne.has(e.element)||ne.set(e.element,new Map);let a=e.attributeName.slice(2),o=ne.get(e.element);return o&&o.has(a)?o.get(a):new be(e.element,a)}};function $a(t,e){return t instanceof He&&t.attributeName.startsWith("on")?(be.for(t).set(e),t.element.removeAttributeNS(t.attributeNamespace,t.attributeName),!0):!1}function Ma(t,e){return e instanceof ye&&t instanceof fe?(e.renderInto(t),!0):!1}function Ca(t,e){return e instanceof DocumentFragment&&t instanceof fe?(e.childNodes.length&&t.replace(...e.childNodes),!0):!1}function Oa(t,e){if(t instanceof He){let a=t.attributeNamespace,o=t.element.getAttributeNS(a,t.attributeName);return String(e)!==o&&(t.value=String(e)),!0}return t.value=String(e),!0}function Ra(t,e){if(typeof e=="boolean"&&t instanceof He){let a=t.attributeNamespace,o=t.element.hasAttributeNS(a,t.attributeName);return e!==o&&(t.booleanValue=e),!0}return!1}function Ia(t,e){return e===!1&&t instanceof fe?(t.replace(""),!0):!1}function Pa(t,e){Ra(t,e)||$a(t,e)||Ia(t,e)||Ma(t,e)||Ca(t,e)||Oa(t,e)}var Ue=new WeakMap,bt=new WeakMap,yt=new WeakMap,ye=class{constructor(e,a,o){this.strings=e;this.values=a;this.processor=o}get template(){if(Ue.has(this.strings))return Ue.get(this.strings);{let e=document.createElement("template"),a=this.strings.length-1;return e.innerHTML=this.strings.reduce((o,i,r)=>o+i+(r<a?`{{ ${r} }}`:""),""),Ue.set(this.strings,e),e}}renderInto(e){let a=this.template;if(bt.get(e)!==a){bt.set(e,a);let i=new ft(a,this.values,this.processor);yt.set(e,i),e instanceof fe?e.replace(...i.children):e.appendChild(i);return}let o=yt.get(e);o&&o.update(this.values)}},vt=new Map,_a=Sa(Pa);function l(t,...e){let a=[""],o=[],i,r=!1,n=(m,g=[])=>{a[a.length-1]=a[a.length-1]+m[0],g.forEach((T,y)=>{(i=T==null?void 0:T.$static$)!==void 0?(i.forEach(A=>{n(A.strings,A.values)}),a[a.length-1]=a[a.length-1]+m[y+1],r=!0):(o.push(T),a.push(m[y+1]))})};if(n(t,e),r){let m=a.join("$$html$$");t=vt.get(m),t===void 0&&(a.raw=a,vt.set(m,t=a)),e=o}return new ye(t,e,_a)}function ve(t,e){t.renderInto(e)}function b(t,e){let a=document.createElement("template");return a.innerHTML=t,new ft(a,e)}var Fe=(...t)=>({$static$:t.map(e=>e instanceof ye?e:/\w-/.test(e)?{strings:[e]}:{strings:[]})});var kt=`
  :host {
    cursor: pointer;
  }
  media-time-display {
    color: inherit;
  }
`,Et=document.createElement("template");Et.innerHTML=`
  <style>
    ${kt}
  </style>
  <media-time-display show-duration></media-time-display>
`;var Tt=["Enter"," "],se=class extends HTMLElement{constructor(){super();var e,a;this.attachShadow({mode:"open"}),(e=this.shadowRoot)==null||e.appendChild(this.constructor.template.content.cloneNode(!0)),this.timeDisplayEl=(a=this.shadowRoot)==null?void 0:a.querySelector("media-time-display")}toggleTimeDisplay(){var e,a,o;((e=this.timeDisplayEl)==null?void 0:e.hasAttribute("remaining"))?(a=this.timeDisplayEl)==null||a.removeAttribute("remaining"):(o=this.timeDisplayEl)==null||o.setAttribute("remaining","")}connectedCallback(){let e=a=>{let{key:o}=a;if(!Tt.includes(o)){this.removeEventListener("keyup",e);return}this.toggleTimeDisplay()};this.addEventListener("keydown",a=>{let{metaKey:o,altKey:i,key:r}=a;if(o||i||!Tt.includes(r)){this.removeEventListener("keyup",e);return}this.addEventListener("keyup",e)}),this.addEventListener("click",this.toggleTimeDisplay)}};se.styles=kt,se.template=Et;globalThis.customElements.get("mxp-time-display")||(globalThis.customElements.define("mxp-time-display",se),globalThis.MxpTimeDisplay=se);var xt=`:host(:not([audio])) {
  --secondary-color: transparent;
}

:host {
  --_primary-color: var(--primary-color, #fff);

  --media-icon-color: var(--_primary-color);
  --media-range-thumb-background: var(--_primary-color);
  --media-range-bar-color: var(--_primary-color);
  --media-control-background: var(--secondary-color);
  --media-control-hover-background: var(--secondary-color);
  --media-time-buffered-color: rgba(255, 255, 255, 0.4);
  --media-range-track-background: rgba(255, 255, 255, 0.5);
  --media-range-track-border-radius: 3px;
  --media-preview-thumbnail-border: 1px solid #fff;
  --media-preview-thumbnail-border-radius: 2px;
  --media-preview-time-margin: 5px 0 2px;
  color: var(--_primary-color);
  display: inline-block;
  width: 100%;
  height: 100%;
}

:host(.two-tone:not([audio])) {
  --mux-time-range-padding: 0px; /* px is needed in calc() */
  --media-preview-thumbnail-border: 0;
  --media-preview-thumbnail-border-radius: 2px 2px 0 0;
  --media-preview-time-border-radius: 0 0 2px 2px;
  --media-preview-time-margin: 0 0 8px;
  --media-preview-time-text-shadow: none;
}

:host([audio]) {
  --media-preview-time-border-radius: 3px;
  --media-preview-time-margin: 0 0 5px;
  --media-preview-time-text-shadow: none;
}

:host(.two-tone:not([audio])) media-time-range {
  --media-range-track-border-radius: 0;
}

:host([audio]) ::slotted([slot='media']) {
  height: 0px;
}

:host([audio]) media-controller {
  background: transparent;
}

:host([audio]) media-controller::part(vertical-layer) {
  background: transparent;
}

:host([audio]) media-control-bar {
  width: 100%;
}

media-airplay-button[media-airplay-unavailable],
media-cast-button[media-cast-unavailable],
media-volume-range[media-volume-unavailable],
media-airplay-button[media-airplay-unavailable],
media-captions-button:not(:is([media-captions-list], [media-subtitles-list])) {
  display: none;
}

media-volume-range[media-volume-unavailable] {
  display: none;
}

media-pip-button[media-pip-unavailable] {
  display: none;
}

media-controller {
  width: 100%;
  height: 100%;
}

:host media-time-range {
  color: var(--_primary-color);
}

:host(:not([audio])) media-time-range {
  --media-range-padding-left: var(--mux-time-range-padding, 10px);
  --media-range-padding-right: var(--mux-time-range-padding, 10px);
  width: 100%;
  z-index: 10;
  height: 10px;
  bottom: -2px;
  background: linear-gradient(
    180deg,
    transparent,
    transparent 3px,
    var(--media-control-background) 3px,
    var(--media-control-background) 8px,
    transparent 8px,
    transparent
  );
}

media-control-bar {
  --media-button-icon-width: 18px;
}

media-control-bar :is([role='button'], [role='switch'], button) {
  height: 44px;
}

.size-extra-small media-control-bar [role='button'],
.size-extra-small media-control-bar [role='switch'] {
  height: auto;
  padding: 4.4% 3.2%;
}

.mxp-spacer {
  flex-grow: 1;
  height: 100%;
  background-color: var(--media-control-background, rgba(20, 20, 30, 0.7));
}

/* Add a small space on the right to have the play button and
 * fullscreen button aligned in relation to the progress bar. */
.size-large .mxp-padding-2 {
  width: 2px;
  height: 100%;
  background-color: var(--media-control-background, rgba(20, 20, 30, 0.7));
}

media-controller::part(vertical-layer) {
  transition: background-color 1s;
}

media-controller:is([media-paused], :not([user-inactive]))::part(vertical-layer) {
  background-color: rgba(0, 0, 0, 0.6);
  transition: background-color 0.25s;
}

.mxp-center-controls {
  --media-button-icon-width: 100%;
  --media-button-icon-height: auto;
  pointer-events: none;
  width: 100%;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
}

.mxp-center-controls media-play-button {
  --media-control-background: transparent;
  --media-control-hover-background: transparent;
  padding: 0;
  width: max(27px, min(9%, 90px));
}

.mxp-center-controls media-seek-backward-button,
.mxp-center-controls media-seek-forward-button {
  --media-control-background: transparent;
  --media-control-hover-background: transparent;
  padding: 0;
  margin: 0 10%;
  width: min(7%, 70px);
}

media-loading-indicator {
  --media-loading-icon-width: 100%;
  --media-button-icon-height: auto;
  pointer-events: none;
  position: absolute;
  width: min(15%, 150px);
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
}

/* Intentionally don't target the div for transition but the children
 of the div. Prevents messing with media-chrome's autohide feature. */
media-loading-indicator + div * {
  transition: opacity 0.15s;
  opacity: 1;
}

media-loading-indicator[media-loading]:not([media-paused]) ~ div > * {
  opacity: 0;
  transition-delay: 400ms;
}

media-volume-range {
  width: min(100%, 100px);
}

media-time-display {
  white-space: nowrap;
}

:is(media-time-display, media-text-display, media-playback-rate-button) {
  color: inherit;
}
`;var At=`<svg aria-hidden="true" viewBox="0 0 20 18" slot="airplay">
  <path
    d="M10.19 11.22a.25.25 0 0 0-.38 0l-5.46 6.37a.25.25 0 0 0 .19.41h10.92a.25.25 0 0 0 .19-.41Z"
  />
  <path
    d="M19 0H1a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h2.94L5 13.75H1.25V1.25h17.5v12.5H15L16.06 15H19a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1Z"
  />
</svg>
`;var wt=`<svg aria-hidden="true" viewBox="0 0 20 18" slot="off">
  <path
    d="M19.83 2.68a2.58 2.58 0 0 0-2.3-2.5C15.72.06 12.86 0 10 0S4.28.06 2.47.18a2.58 2.58 0 0 0-2.3 2.5 115.86 115.86 0 0 0 0 12.64 2.58 2.58 0 0 0 2.3 2.5c1.81.12 4.67.18 7.53.18s5.72-.06 7.53-.18a2.58 2.58 0 0 0 2.3-2.5 115.86 115.86 0 0 0 0-12.64Zm-1.49 12.53a1.11 1.11 0 0 1-.91 1.11c-1.67.11-4.45.18-7.43.18s-5.76-.07-7.43-.18a1.11 1.11 0 0 1-.91-1.11 122.5 122.5 0 0 1 0-12.42 1.11 1.11 0 0 1 .91-1.11C4.24 1.57 7 1.5 10 1.5s5.76.07 7.43.18a1.11 1.11 0 0 1 .91 1.11 122.5 122.5 0 0 1 0 12.42ZM7.84 11a1.55 1.55 0 0 1-.76.18 1.57 1.57 0 0 1-.71-.18 1.69 1.69 0 0 1-.57-.42 2.1 2.1 0 0 1-.38-.58 2.47 2.47 0 0 1 0-1.64 2 2 0 0 1 .39-.66 1.73 1.73 0 0 1 .58-.42 1.81 1.81 0 0 1 .73-.16 1.68 1.68 0 0 1 .7.14 1.39 1.39 0 0 1 .51.39l1.08-.89a2.18 2.18 0 0 0-.47-.44A2.81 2.81 0 0 0 8.4 6a2.91 2.91 0 0 0-.58-.15 2.71 2.71 0 0 0-.56 0A4.08 4.08 0 0 0 5.88 6a3.27 3.27 0 0 0-1.09.67 3.14 3.14 0 0 0-.71 1.06 3.62 3.62 0 0 0-.26 1.39 3.57 3.57 0 0 0 .26 1.38 3 3 0 0 0 .71 1.06 3.27 3.27 0 0 0 1.09.67 3.85 3.85 0 0 0 1.38.23 3.2 3.2 0 0 0 1.28-.27 2.49 2.49 0 0 0 1-.83l-1.17-.88a1.42 1.42 0 0 1-.53.52Zm6.62 0a1.58 1.58 0 0 1-.76.18A1.54 1.54 0 0 1 13 11a1.69 1.69 0 0 1-.57-.42A2.12 2.12 0 0 1 12 10a2.29 2.29 0 0 1 .39-2.3 1.84 1.84 0 0 1 1.32-.58 1.71 1.71 0 0 1 .7.14 1.39 1.39 0 0 1 .51.39L16 6.73a2.43 2.43 0 0 0-.47-.44A3.22 3.22 0 0 0 15 6a3 3 0 0 0-.57-.15 2.87 2.87 0 0 0-.57 0A4.06 4.06 0 0 0 12.5 6a3.17 3.17 0 0 0-1.09.67 3 3 0 0 0-.72 1.06 3.62 3.62 0 0 0-.25 1.39 3.57 3.57 0 0 0 .25 1.38 2.93 2.93 0 0 0 .72 1.06 3.17 3.17 0 0 0 1.09.67 3.83 3.83 0 0 0 1.37.23 3.16 3.16 0 0 0 1.28-.27 2.45 2.45 0 0 0 1-.83L15 10.51a1.49 1.49 0 0 1-.54.49Z"
  />
</svg>
`;var Lt=`<svg aria-hidden="true" viewBox="0 0 20 18" slot="on">
  <path
    d="M19.83 2.68a2.58 2.58 0 0 0-2.3-2.5C13.91-.06 6.09-.06 2.47.18a2.58 2.58 0 0 0-2.3 2.5 115.86 115.86 0 0 0 0 12.64 2.58 2.58 0 0 0 2.3 2.5c3.62.24 11.44.24 15.06 0a2.58 2.58 0 0 0 2.3-2.5 115.86 115.86 0 0 0 0-12.64ZM8.42 12.78a3.63 3.63 0 0 1-1.51.32 4.76 4.76 0 0 1-1.63-.27A4 4 0 0 1 4 12a3.67 3.67 0 0 1-.84-1.26 4.23 4.23 0 0 1-.3-1.63 4.28 4.28 0 0 1 .3-1.64A3.53 3.53 0 0 1 4 6.26a3.89 3.89 0 0 1 1.29-.8 4.76 4.76 0 0 1 1.63-.27 4.06 4.06 0 0 1 .67.06 4.57 4.57 0 0 1 .68.18 3.59 3.59 0 0 1 .64.34 2.7 2.7 0 0 1 .55.52l-1.27 1a1.79 1.79 0 0 0-.6-.46 2 2 0 0 0-.83-.16 2 2 0 0 0-1.56.69 2.35 2.35 0 0 0-.46.77 2.78 2.78 0 0 0-.16 1 2.74 2.74 0 0 0 .16 1 2.39 2.39 0 0 0 .46.77 2.07 2.07 0 0 0 .67.5 2 2 0 0 0 .84.18 1.87 1.87 0 0 0 .9-.21 1.78 1.78 0 0 0 .65-.6l1.38 1a2.88 2.88 0 0 1-1.22 1.01Zm7.52 0a3.63 3.63 0 0 1-1.51.32 4.76 4.76 0 0 1-1.63-.27 3.89 3.89 0 0 1-1.28-.83 3.55 3.55 0 0 1-.85-1.26 4.23 4.23 0 0 1-.3-1.63 4.28 4.28 0 0 1 .3-1.64 3.43 3.43 0 0 1 .85-1.25 3.75 3.75 0 0 1 1.28-.8 4.76 4.76 0 0 1 1.63-.27 4 4 0 0 1 .67.06 4.27 4.27 0 0 1 .68.18 3.59 3.59 0 0 1 .64.34 2.46 2.46 0 0 1 .55.52l-1.27 1a1.79 1.79 0 0 0-.6-.46 2 2 0 0 0-.83-.16 2 2 0 0 0-1.56.69 2.35 2.35 0 0 0-.46.77 3 3 0 0 0-.16 1 3 3 0 0 0 .16 1 2.58 2.58 0 0 0 .46.77 2.07 2.07 0 0 0 .67.5 2 2 0 0 0 .84.18 1.87 1.87 0 0 0 .9-.21 1.78 1.78 0 0 0 .65-.6l1.38 1a2.82 2.82 0 0 1-1.21 1.05Z"
  />
</svg>
`;var St=`<svg aria-hidden="true" viewBox="0 0 20 18" slot="enter">
  <path d="M0 12.5V14C2.2056 14 4 15.7944 4 18H5.5C5.5 14.9624 3.0376 12.5 0 12.5Z"/>
  <path d="M0 15.5V18H2.5C2.5 16.6193 1.3807 15.5 0 15.5Z"/>
  <path d="M0 9.5V11C3.8599 11 7 14.1402 7 18H8.5C8.5 13.3055 4.6945 9.5 0 9.5Z"/>
  <path d="M19 -0.000213623H1C0.4478 -0.000213623 0 0.447386 0 0.999786V7.98359C0.4243 7.98359 0.8396 8.01859 1.25 8.06979V1.24979H18.75V16.75H9.9302C9.9814 17.1604 10.0164 17.5757 10.0164 18H19C19.5523 18 20 17.5522 20 17V0.999786C20 0.447386 19.5523 -0.000213623 19 -0.000213623Z"/>
</svg>
`;var $t=`<svg aria-hidden="true" viewBox="0 0 20 18" slot="exit">
  <path d="M0 12.5V14C2.2056 14 4 15.7944 4 18H5.5C5.5 14.9624 3.0376 12.5 0 12.5Z" />
  <path d="M0 15.5V18H2.5C2.5 16.6193 1.3807 15.5 0 15.5Z" />
  <path d="M0 9.5V11C3.8599 11 7 14.1402 7 18H8.5C8.5 13.3055 4.6945 9.5 0 9.5Z" />
  <path d="M19 -0.000198364H1C0.4478 -0.000198364 0 0.447402 0 0.999802V7.9836C0.4243 7.9836 0.8396 8.0186 1.25 8.0698V1.2498H18.75V16.75H9.9302C9.9814 17.1604 10.0164 17.5757 10.0164 18H19C19.5523 18 20 17.5522 20 17V0.999802C20 0.447402 19.5523 -0.000198364 19 -0.000198364Z" />
  <path d="M17.5 2.4998H2.5V8.311C6.0193 9.2171 8.783 11.9807 9.689 15.5001H17.5V2.4998Z" />
</svg>
`;var Mt=`<svg aria-hidden="true" viewBox="0 0 18 18" slot="enter">
  <path
    d="M17.25 11.5a.76.76 0 0 0-.75.75v4.25h-4.25a.75.75 0 0 0 0 1.5h5a.76.76 0 0 0 .75-.75v-5a.76.76 0 0 0-.75-.75Zm0-11.5h-5a.76.76 0 0 0-.75.75.76.76 0 0 0 .75.75h4.25v4.25a.75.75 0 0 0 1.5 0v-5a.76.76 0 0 0-.75-.75ZM5.75 16.5H1.5v-4.25a.76.76 0 0 0-.75-.75.76.76 0 0 0-.75.75v5a.76.76 0 0 0 .75.75h5a.75.75 0 0 0 0-1.5Zm0-16.5h-5A.76.76 0 0 0 0 .75v5a.76.76 0 0 0 .75.75.76.76 0 0 0 .75-.75V1.5h4.25A.76.76 0 0 0 6.5.75.76.76 0 0 0 5.75 0Z"
  />
</svg>
`;var Ct=`<svg aria-hidden="true" viewBox="0 0 18 18" slot="exit">
  <path
    d="M17.25 11.5h-5a.76.76 0 0 0-.75.75v5a.75.75 0 0 0 1.5 0V13h4.25a.75.75 0 0 0 0-1.5Zm-5-5h5a.75.75 0 0 0 0-1.5H13V.75a.75.75 0 0 0-1.5 0v5a.76.76 0 0 0 .75.75Zm-6.5 5h-5a.75.75 0 0 0 0 1.5H5v4.25a.75.75 0 0 0 1.5 0v-5a.76.76 0 0 0-.75-.75Zm0-11.5A.76.76 0 0 0 5 .75V5H.75a.75.75 0 0 0 0 1.5h5a.76.76 0 0 0 .75-.75v-5A.76.76 0 0 0 5.75 0Z"
  />
</svg>
`;var Ot=`<svg aria-hidden="true" viewBox="0 0 18 18" slot="pause">
  <path
    d="M3 16.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v15ZM11.5 1a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5h-3Z"
  />
</svg>
`;var Rt=`<svg aria-hidden="true" viewBox="0 0 20 18" slot="enter">
  <path
    d="M19 0H1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h6.75v-1.25h-6.5V1.25h17.5v6.5H20V1a1 1 0 0 0-1-1Zm0 10h-8a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1Zm-.5 6.5h-7v-5h7Z"
  />
</svg>
`;var It=`<svg aria-hidden="true" viewBox="0 0 20 18" slot="exit">
  <path
    d="M19 0H1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h6.75v-1.25h-6.5V1.25h17.5v6.5H20V1a1 1 0 0 0-1-1Zm0 10h-8a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1Zm-.5 6.5h-7v-5h7Z"
  />
</svg>
`;var Pt=`<svg aria-hidden="true" viewBox="0 0 18 18" slot="play">
  <path
    d="m3.73 17.93 14.05-8.54a.46.46 0 0 0 0-.78L3.73.07A.48.48 0 0 0 3 .46v17.07a.48.48 0 0 0 .73.4Z"
  />
</svg>
`;var _t=`<svg aria-hidden="true" viewBox="0 0 16 18" slot="backward">
  <path
    d="M8.75 3.42H4.68l2.14-2.14A.75.75 0 0 0 5.76.22L2.22 3.75a.77.77 0 0 0 0 1.07l3.54 3.53a.75.75 0 0 0 1.06 0 .75.75 0 0 0 0-1.06L4.45 4.92h4.3A5.75 5.75 0 0 1 11 16a.75.75 0 0 0 .29 1.44.72.72 0 0 0 .29-.06A7.25 7.25 0 0 0 8.75 3.42Z"
  />
  <text
    class="value"
    transform="translate(.6 17.8)"
    style="font-size: 8px; font-family: 'ArialMT', 'Arial'"
  >
    {{value}}
  </text>
  <path style="fill: none" d="M0 0h16v18H0z" />
</svg>
`;var Dt=`<svg aria-hidden="true" viewBox="0 0 16 18" slot="forward">
  <path
    d="M7.25 3.42h4.07L9.18 1.28A.75.75 0 0 1 10.24.22l3.54 3.53a.77.77 0 0 1 0 1.07l-3.54 3.53a.75.75 0 0 1-1.06 0 .75.75 0 0 1 0-1.06l2.37-2.37h-4.3A5.75 5.75 0 0 0 5 16a.75.75 0 0 1-.29 1.44.72.72 0 0 1-.29-.06A7.25 7.25 0 0 1 7.25 3.42Z"
  />
  <text
    class="value"
    transform="translate(6.5 17.8)"
    style="font-size: 8px; font-family: 'ArialMT', 'Arial'"
  >
    {{value}}
  </text>
  <path style="fill: none" d="M0 0h16v18H0z" />
</svg>
`;var Nt=`<svg aria-hidden="true" viewBox="0 0 18 18" slot="high">
  <path
    d="m8.14 1.86-4 4a.49.49 0 0 1-.35.14H.25a.25.25 0 0 0-.25.25v5.5a.25.25 0 0 0 .25.25h3.54a.49.49 0 0 1 .36.15l4 4a.5.5 0 0 0 .85-.36V2.21a.5.5 0 0 0-.86-.35ZM10.88.3v1.52A7.52 7.52 0 0 1 16.47 9a7.52 7.52 0 0 1-5.59 7.18v1.52A9 9 0 0 0 18 9 9 9 0 0 0 10.88.3ZM14.44 9a5.49 5.49 0 0 0-3.56-5.1v1.66a3.93 3.93 0 0 1 0 6.88v1.66A5.49 5.49 0 0 0 14.44 9Z"
  />
  <path style="fill: none" d="M0 0h18v18H0z" />
</svg>
`;var Vt=`<svg aria-hidden="true" viewBox="0 0 18 18" slot="low">
  <path
    d="m8.14 1.86-4 4a.49.49 0 0 1-.35.14H.25a.25.25 0 0 0-.25.25v5.5a.25.25 0 0 0 .25.25h3.54a.49.49 0 0 1 .36.15l4 4a.5.5 0 0 0 .85-.36V2.21a.5.5 0 0 0-.86-.35ZM14.44 9a5.49 5.49 0 0 0-3.56-5.1v1.66a3.93 3.93 0 0 1 0 6.88v1.66A5.49 5.49 0 0 0 14.44 9Z"
  />
  <path style="fill: none" d="M0 0h18v18H0z" />
</svg>
`;var Bt=`<svg aria-hidden="true" viewBox="0 0 18 18" slot="medium">
  <path
    d="m8.14 1.86-4 4a.49.49 0 0 1-.35.14H.25a.25.25 0 0 0-.25.25v5.5a.25.25 0 0 0 .25.25h3.54a.49.49 0 0 1 .36.15l4 4a.5.5 0 0 0 .85-.36V2.21a.5.5 0 0 0-.86-.35ZM14.44 9a5.49 5.49 0 0 0-3.56-5.1v1.66a3.93 3.93 0 0 1 0 6.88v1.66A5.49 5.49 0 0 0 14.44 9Z"
  />
  <path style="fill: none" d="M0 0h18v18H0z" />
</svg>
`;var Ht=`<svg aria-hidden="true" viewBox="0 0 18 18" slot="off">
  <path
    d="m0 1.05 4.48 4.47-.33.33a.49.49 0 0 1-.36.15H.25a.25.25 0 0 0-.25.25v5.5a.25.25 0 0 0 .25.25h3.54a.49.49 0 0 1 .36.15l4 4a.48.48 0 0 0 .36.15.5.5 0 0 0 .5-.5v-5.75l4.67 4.66a7.71 7.71 0 0 1-2.79 1.47v1.52a9.32 9.32 0 0 0 3.87-1.91L17 18l1-1L1.06 0Zm5.36 5.36L7.75 8.8V14L5 11.26a1.74 1.74 0 0 0-1.24-.51H1.25v-3.5h2.54A1.74 1.74 0 0 0 5 6.74ZM16.47 9a7.19 7.19 0 0 1-.89 3.47l1.11 1.1A8.64 8.64 0 0 0 18 9 9 9 0 0 0 10.88.3v1.52A7.52 7.52 0 0 1 16.47 9ZM9 5.88V2.21a.5.5 0 0 0-.5-.5.48.48 0 0 0-.36.15L6.56 3.44ZM12.91 9a4.28 4.28 0 0 1-.07.72l1.22 1.22A5.2 5.2 0 0 0 14.44 9a5.49 5.49 0 0 0-3.56-5.1v1.66A4 4 0 0 1 12.91 9Z"
  />
  <path style="fill: none" d="M0 0h18v18H0z" />
</svg>
`;var Ut=()=>b(At),Ft=()=>b(wt),Kt=()=>b(Lt),Yt=()=>b(St),Zt=()=>b($t),zt=()=>b(Mt),Wt=()=>b(Ct),jt=()=>b(Ot),qt=()=>b(Rt),Gt=()=>b(It),Xt=()=>b(Pt),Jt=t=>b(_t,t),Qt=t=>b(Dt,t),ea=()=>b(Nt),ta=()=>b(Vt),aa=()=>b(Bt),ia=()=>b(Ht);import{StreamTypes as L}from"@mux/playback-core";var R={LG:"large",SM:"small",XS:"extra-small"},u={mediaChrome:"layer media-layer poster-layer vertical-layer centered-layer",centerPlay:"center play button",centerSeekBackward:"center seek-backward button",centerSeekForward:"center seek-forward button",play:"play button",seekBackward:"seek-backward button",seekForward:"seek-forward button",mute:"mute button",captions:"captions button",airplay:"airplay button",pip:"pip button",fullscreen:"fullscreen button",cast:"cast button",playbackRate:"playbackrate button",volumeRange:"volume range",timeRange:"time range",timeDisplay:"time display"},Ke=class extends ei{static get observedAttributes(){return["audio","nohotkeys","stream-type","player-size","default-hidden-captions","forward-seek-offset","backward-seek-offset"]}attributeChangedCallback(){this.render()}render(){let e={audio:this.hasAttribute("audio"),nohotkeys:this.hasAttribute("nohotkeys"),streamType:this.getAttribute("stream-type"),playerSize:this.getAttribute("player-size"),defaultHiddenCaptions:this.hasAttribute("default-hidden-captions"),forwardSeekOffset:this.getAttribute("forward-seek-offset"),backwardSeekOffset:this.getAttribute("backward-seek-offset")};ve(l`
        <style>
          ${xt}
        </style>
        <media-controller
          nohotkeys="${e.nohotkeys||!1}"
          audio="${e.audio||!1}"
          class="size-${e.playerSize}"
          exportparts="${u.mediaChrome.split(" ").join(", ")}"
        >
          <slot name="media" slot="media"></slot>
          <media-loading-indicator slot="centered-chrome" no-auto-hide></media-loading-indicator>
          ${ti(e)}
          <slot></slot>
        </media-controller>
      `,this.shadowRoot)}};customElements.get("media-theme-mux")||customElements.define("media-theme-mux",Ke);var ti=t=>{let{streamType:e,playerSize:a,audio:o}=t;if(o)switch(e){case L.LIVE:case L.LL_LIVE:return oi();case L.DVR:case L.LL_DVR:return ii(t);case L.ON_DEMAND:default:return ai(t)}switch(e){case L.LIVE:case L.LL_LIVE:switch(a){case R.LG:return di(t);case R.SM:return li(t);case R.XS:return si(t)}case L.DVR:case L.LL_DVR:switch(a){case R.LG:return ui(t);case R.SM:return ci(t);case R.XS:return mi(t)}case L.ON_DEMAND:default:switch(a){case R.LG:return ni(t);case R.SM:return ri(t);case R.XS:return Ye(t)}}},x=({part:t=u.play}={})=>l`
  <media-play-button part="${t}">
    ${Xt()}
    ${jt()}
  </media-play-button>
`,G=({backwardSeekOffset:t,part:e=u.seekBackward})=>l`
  <media-seek-backward-button seek-offset="${t}" part="${e}">
    ${Jt({value:t})}
  </media-seek-backward-button>
`,X=({forwardSeekOffset:t,part:e=u.seekForward})=>l`
  <media-seek-forward-button seek-offset="${t}" part="${e}">
    ${Qt({value:t})}
  </media-seek-forward-button>
`,S=()=>l`
  <media-mute-button part="${u.mute}">
    ${ea()}
    ${aa()}
    ${ta()}
    ${ia()}
  </media-mute-button>
`,Z=t=>l`
<media-captions-button default-showing="${!t.defaultHiddenCaptions}" part="${u.captions}">
  ${Ft()}
  ${Kt()}
</media-captions-button>`,$=()=>l`
<media-airplay-button part="${u.airplay}">
  ${Ut()}
</media-airplay-button>`,z=()=>l`
<media-pip-button part="${u.pip}">
  ${qt()}
  ${Gt()}
</media-pip-button>`,W=()=>l`
<media-fullscreen-button part="${u.fullscreen}">
  ${zt()}
  ${Wt()}
</media-fullscreen-button>`,M=()=>l`
<media-cast-button part="${u.cast}">
  ${Yt()}
  ${Zt()}
</media-cast-button>`,ke=()=>l`
<media-playback-rate-button part="${u.playbackRate}">
</media-playback-rate-button>`,I=()=>l`
<media-volume-range part="${u.volumeRange}">
</media-volume-range>`,J=()=>l`
<media-time-range part="${u.timeRange}">
</media-time-range>`,Ee=()=>l`
<mxp-time-display part="${u.timeDisplay}">
</mxp-time-display>`,ai=t=>l`
  <media-control-bar>
    ${x()}
    ${G(t)}
    ${X(t)}
    ${Ee()}
    ${J()}
    ${S()}
    ${I()}
    ${ke()}
    ${$()}
    ${M()}
  </media-control-bar>
`,ii=t=>l`
  <media-control-bar>
    ${x()}
    <slot name="seek-to-live-button"></slot>
    ${G(t)}
    ${X(t)}
    ${Ee()}
    ${J()}
    ${S()}
    ${I()}
    ${ke()}
    ${$()}
    ${M()}
  </media-control-bar>
`,oi=()=>l`
  <media-control-bar>
    ${x()}
    <slot name="seek-to-live-button"></slot>
    ${S()}
    ${I()}
    ${$()}
    ${M()}
  </media-control-bar>
`,Ye=t=>l`
  <media-control-bar slot="top-chrome">
    ${Z(t)}
    <div class="mxp-spacer"></div>
    ${$()}
    ${M()}
    ${z()}
  </media-control-bar>
  <div slot="centered-chrome" class="mxp-center-controls">
    ${x({part:u.centerPlay})}
  </div>
  <media-control-bar>
    ${S()}
    <div class="mxp-spacer"></div>
    ${W()}
  </media-control-bar>
`,ri=t=>l`
  <media-control-bar slot="top-chrome" style="justify-content: flex-end;">
    ${Z(t)}
    ${$()}
    ${M()}
    ${z()}
  </media-control-bar>
  <div slot="centered-chrome" class="mxp-center-controls">
    ${G({...t,part:u.centerSeekBackward})}
    ${x({part:u.centerPlay})}
    ${X({...t,part:u.centerSeekForward})}
  </div>
  ${J()}
  <media-control-bar>
    ${Ee()}
    ${S()}
    ${I()}
    <div class="mxp-spacer"></div>
    ${ke()}
    ${W()}
    <div class="mxp-padding-2"></div>
  </media-control-bar>
`,ni=t=>l`
  <div slot="centered-chrome" class="mxp-center-controls">
    ${x({part:u.centerPlay})}
  </div>
  ${J()}
  <media-control-bar>
    ${x()}
    ${G(t)}
    ${X(t)}
    ${Ee()}
    ${S()}
    ${I()}
    <div class="mxp-spacer"></div>
    ${ke()}
    ${Z(t)}
    ${$()}
    ${M()}
    ${z()}
    ${W()}
    <div class="mxp-padding-2"></div>
  </media-control-bar>
`,si=Ye,li=t=>l`
  <media-control-bar slot="top-chrome">
    <slot name="seek-to-live-button"></slot>
    <div class="mxp-spacer"></div>
    ${Z(t)}
    ${$()}
    ${M()}
    ${z()}
  </media-control-bar>
  <div slot="centered-chrome" class="mxp-center-controls">
    ${x({part:u.centerPlay})}
  </div>
  <media-control-bar>
    ${S()}
    ${I()}
    <div class="mxp-spacer"></div>
    ${W()}
  </media-control-bar>
`,di=t=>l`
  <media-control-bar slot="top-chrome">
    <slot name="seek-to-live-button"></slot>
  </media-control-bar>
  <div slot="centered-chrome" class="mxp-center-controls">
    ${x({part:u.centerPlay})}
  </div>
  <media-control-bar>
    ${S()}
    ${I()}
    <div class="mxp-spacer"></div>
    ${Z(t)}
    ${$()}
    ${M()}
    ${z()}
    ${W()}
  </media-control-bar>
`,mi=Ye,ci=t=>l`
  <media-control-bar slot="top-chrome" style="justify-content: flex-end;">
    ${Z(t)}
    ${$()}
    ${M()}
    ${z()}
  </media-control-bar>
  <div slot="centered-chrome" class="mxp-center-controls">
    ${G({...t,part:u.centerSeekBackward})}
    ${x({part:u.centerPlay})}
    ${X({...t,part:u.centerSeekForward})}
  </div>
  ${J()}
  <media-control-bar>
    ${S()}
    ${I()}
    <slot name="seek-to-live-button"></slot>
    <div class="mxp-spacer"></div>
    ${W()}
    <div class="mxp-padding-2"></div>
  </media-control-bar>
`,ui=t=>l`
  <div slot="centered-chrome" class="mxp-center-controls">
    ${x({part:u.centerPlay})}
  </div>
  ${J()}
  <media-control-bar>
    ${x()}
    ${G(t)}
    ${X(t)}
    ${S()}
    ${I()}
    <slot name="seek-to-live-button"></slot>
    <div class="mxp-spacer"></div>
    ${Z(t)}
    ${$()}
    ${M()}
    ${z()}
    ${W()}
    <div class="mxp-padding-2"></div>
  </media-control-bar>
`;var oa=`
  :host {
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    box-sizing: border-box;
    color: #fff;
    line-height: 18px;
    font-family: Arial, sans-serif;
    padding: var(--media-dialog-backdrop-padding, 0);
    background: var(--media-dialog-backdrop-background,
      linear-gradient(to bottom, rgba(20, 20, 30, 0.7) 50%, rgba(20, 20, 30, 0.9))
    );
    /* Needs to use !important to prevent overwrite of media-chrome */
    transition: var(--media-dialog-transition-open, visibility .2s, opacity .2s) !important;
    transform: var(--media-dialog-transform-open, none) !important;
    visibility: visible !important;
    opacity: 1 !important;
    pointer-events: auto !important;
  }

  :host(:not([open])) {
    /* Needs to use !important to prevent overwrite of media-chrome */
    transition: var(--media-dialog-transition-close, visibility .1s, opacity .1s) !important;
    transform: var(--media-dialog-transform-close, none) !important;
    visibility: hidden !important;
    opacity: 0 !important;
    pointer-events: none !important;
  }

  /*
    Only show outline when keyboard focusing.
    https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo
    :host-context support is bad https://caniuse.com/mdn-css_selectors_host-context
  */
  :host-context([media-keyboard-control]) ::slotted(:focus),
  :host-context([media-keyboard-control]) :focus {
    box-shadow: 0 0 0 2px rgba(27, 127, 204, 0.9);
  }

  .dialog {
    position: relative;
    box-sizing: border-box;
    background: var(--media-dialog-background, none);
    padding: var(--media-dialog-padding, 10px);
    width: min(320px, 100%);
    word-wrap: break-word;
    max-height: 100%;
    overflow: auto;
    text-align: center;
    line-height: 1.4;
  }
`,ra=document.createElement("template");ra.innerHTML=`
  <style>
    ${oa}
  </style>

  <div class="dialog">
    <slot></slot>
  </div>
`;var j=class extends HTMLElement{constructor(){super();var e;this.attachShadow({mode:"open"}),(e=this.shadowRoot)==null||e.appendChild(this.constructor.template.content.cloneNode(!0))}show(){this.setAttribute("open",""),this.dispatchEvent(new CustomEvent("open",{composed:!0,bubbles:!0})),na(this)}close(){!this.hasAttribute("open")||(this.removeAttribute("open"),this.dispatchEvent(new CustomEvent("close",{composed:!0,bubbles:!0})),pi(this))}attributeChangedCallback(e,a,o){e==="open"&&a!==o&&(o!=null?this.show():this.close())}connectedCallback(){this.hasAttribute("role")||this.setAttribute("role","dialog"),this.hasAttribute("open")&&na(this)}};j.styles=oa,j.template=ra,j.observedAttributes=["open"];function na(t){let e=new CustomEvent("initfocus",{composed:!0,bubbles:!0,cancelable:!0});if(t.dispatchEvent(e),e.defaultPrevented)return;let a=t.querySelector("[autofocus]:not([disabled])");!a&&t.tabIndex>=0&&(a=t),a||(a=sa(t.shadowRoot)),t._previouslyFocusedElement=document.activeElement,document.activeElement instanceof HTMLElement&&document.activeElement.blur(),t.addEventListener("transitionend",()=>{a instanceof HTMLElement&&a.focus({preventScroll:!0})},{once:!0})}function sa(t){let a=["button","input","keygen","select","textarea"].map(function(i){return i+":not([disabled])"});a.push('[tabindex]:not([disabled]):not([tabindex=""])');let o=t==null?void 0:t.querySelector(a.join(", "));if(!o&&"attachShadow"in Element.prototype){let i=(t==null?void 0:t.querySelectorAll("*"))||[];for(let r=0;r<i.length&&!(i[r].tagName&&i[r].shadowRoot&&(o=sa(i[r].shadowRoot),o));r++);}return o}function pi(t){t._previouslyFocusedElement instanceof HTMLElement&&t._previouslyFocusedElement.focus()}globalThis.customElements.get("media-dialog")||(globalThis.customElements.define("media-dialog",j),globalThis.MediaDialog=j);var Ze=j;var la=document.createElement("template");la.innerHTML=`
  <style>
    ${Ze.styles}

    .close {
      background: none;
      color: inherit;
      border: none;
      padding: 0;
      font: inherit;
      cursor: pointer;
      outline: inherit;
      width: 28px;
      height: 28px;
      position: absolute;
      top: 1rem;
      right: 1rem;
    }
  </style>

  <div class="dialog">
    <slot></slot>
  </div>

  <slot name="close">
    <button class="close" tabindex="0">
      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </slot>
`;var Te=class extends Ze{constructor(){super();var e,a;(a=(e=this.shadowRoot)==null?void 0:e.querySelector(".close"))==null||a.addEventListener("click",()=>{this.close()})}};Te.template=la;globalThis.customElements.get("mxp-dialog")||(globalThis.customElements.define("mxp-dialog",Te),globalThis.MxpDialog=Te);var da=`:host {
  display: inline-block;
}

/* Hide custom elements that are not defined yet */
:not(:defined) {
  display: none;
}

a {
  color: #fff;
  font-size: 0.9em;
  text-decoration: underline;
}

media-controller {
  width: 100%;
  height: 100%;
}

.mxp-seek-to-live-button {
  height: 44px;
  background-color: var(--media-control-background, rgba(20, 20, 30, 0.7));
  color: white;
  border: none;
  cursor: pointer;
}

.mxp-seek-to-live-button[aria-disabled] {
  cursor: default;
  pointer-events: none;
}

.mxp-seek-to-live-button::before {
  content: '\u25CF ';
  color: rgb(118, 118, 118);
  padding-right: 5px;
}

.mxp-seek-to-live-button[aria-disabled]::before {
  color: #fb3c4d;
}
`;import{StreamTypes as Q}from"@mux/playback-core";var ma=t=>l`
  <style>
    ${da}
  </style>
  ${bi(t)}
`,gi=Object.values(u).flatMap(t=>t.split(" ")),fi=[...new Set(gi)].join(", "),bi=t=>{var e,a,o,i,r,n,m,g,T,y,A,E,O,_,h,H,ie,oe,Ge,Xe,Je,Qe,et;return l`
  <${Fe((e=Ne(t.theme))!=null?e:"media-theme-mux")}
    nohotkeys="${(a=t.noHotKeys)!=null?a:!1}"
    audio="${t.audio||!1}"
    style="${(o=ot({"--primary-color":t.primaryColor,"--secondary-color":t.secondaryColor}))!=null?o:!1}"
    class="size-${t.playerSize}${t.secondaryColor?" two-tone":""}"
    stream-type="${t.streamType}"
    player-size="${t.playerSize}"
    default-hidden-captions="${t.defaultHiddenCaptions}"
    forward-seek-offset="${t.forwardSeekOffset}"
    backward-seek-offset="${t.backwardSeekOffset}"
    exportparts="seek-live, ${fi}"
  >
    <mux-video
      slot="media"
      crossorigin
      playsinline
      autoplay="${(i=t.autoplay)!=null?i:!1}"
      muted="${(r=t.muted)!=null?r:!1}"
      loop="${(n=t.loop)!=null?n:!1}"
      preload="${(m=t.preload)!=null?m:!1}"
      debug="${(g=t.debug)!=null?g:!1}"
      prefer-mse="${(T=t.preferMse)!=null?T:!1}"
      start-time="${t.startTime!=null?t.startTime:!1}"
      metadata-video-id="${(y=t.metadataVideoId)!=null?y:!1}"
      metadata-video-title="${(A=t.metadataVideoTitle)!=null?A:!1}"
      metadata-viewer-user-id="${(E=t.metadataViewerUserId)!=null?E:!1}"
      beacon-collection-domain="${(O=t.beaconCollectionDomain)!=null?O:!1}"
      player-software-name="${t.playerSoftwareName}"
      player-software-version="${t.playerSoftwareVersion}"
      env-key="${(_=t.envKey)!=null?_:!1}"
      stream-type="${(h=t.streamType)!=null?h:!1}"
      custom-domain="${(H=t.customDomain)!=null?H:!1}"
      src="${t.src?t.src:t.playbackId?De(t.playbackId,{domain:t.customDomain,token:t.tokens.playback}):!1}"
      poster="${t.poster?t.poster:t.playbackId&&!t.audio?nt(t.playbackId,{domain:t.customDomain,thumbnailTime:(ie=t.thumbnailTime)!=null?ie:t.startTime,token:t.tokens.thumbnail}):!1}"
      cast-src="${t.src?t.src:t.playbackId?De(t.playbackId,{domain:t.customDomain,token:t.tokens.playback}):!1}"
      cast-stream-type="${[Q.LIVE,Q.LL_LIVE].includes(t.streamType)?"live":!1}"
    >
      ${t.playbackId&&!t.audio&&![Q.LIVE,Q.LL_LIVE,Q.DVR,Q.LL_DVR].includes(t.streamType)?l`<track
              label="thumbnails"
              default
              kind="metadata"
              src="${st(t.playbackId,{domain:t.customDomain,token:t.tokens.storyboard})}"
            />`:l``}
    </mux-video>
    <button
      slot="seek-to-live-button"
      part="seek-live button"
      class="mxp-seek-to-live-button"
      aria-disabled="${t.inLiveWindow}"
      onclick="${function(pa){var tt;if((tt=t.onSeekToLive)==null||tt.call(t,pa),t.paused){let ha=new CustomEvent("mediaplayrequest",{composed:!0,bubbles:!0});this.dispatchEvent(ha)}}}"
    >
      Live
    </button>
    <mxp-dialog
      no-auto-hide
      open="${t.isDialogOpen}"
      onclose="${t.onCloseErrorDialog}"
      oninitfocus="${t.onInitFocusDialog}"
    >
      ${((oe=t.dialog)==null?void 0:oe.title)?l`<h3>${t.dialog.title}</h3>`:l``}
      <p>
        ${(Ge=t.dialog)==null?void 0:Ge.message}
        ${((Xe=t.dialog)==null?void 0:Xe.linkUrl)?l`<a
                href="${t.dialog.linkUrl}"
                target="_blank"
                rel="external noopener"
                aria-label="${(Je=t.dialog.linkText)!=null?Je:""} ${s("(opens in a new window)")}"
                >${(Qe=t.dialog.linkText)!=null?Qe:t.dialog.linkUrl}</a
              >`:l``}
      </p>
    </mxp-dialog>
  </${Fe((et=Ne(t.theme))!=null?et:"media-theme-mux")}>
`};import{MediaError as xe}from"@mux/mux-video";function Ae(t,e,a,o,i){var m,g,T;let r={},n={};switch(t.code){case xe.MEDIA_ERR_NETWORK:{switch(r.title=s("Network Error",i),r.message=t.message,(m=t.data)==null?void 0:m.response.code){case 412:{r.title=s("Video is not currently available",i),r.message=s("The live stream or video file are not yet ready.",i),n.message=s("This playback-id may belong to a live stream that is not currently active or an asset that is not ready.",i),n.file="412-not-playable.md";break}case 404:{r.title=s("Video does not exist",i),r.message="",n.message=s("This playback-id does not exist. You may have used an Asset ID or an ID from a different resource.",i),n.file="404-not-found.md";break}case 403:{if(r.title=s("Invalid playback URL",i),r.message=s("The video URL or playback-token are formatted with incorrect or incomplete information.",i),n.message=s("403 error trying to access this playback URL. If this is a signed URL, you might need to provide a playback-token.",i),n.file="missing-signed-tokens.md",!o)break;let{exp:y,aud:A,sub:E}=re(o),O=Date.now()>y*1e3,_=E!==a,h=A!=="v",H={timeStyle:"medium",dateStyle:"medium"};if(O){r.title=s("Video URL has expired",i),r.message=s("The video\u2019s secured playback-token has expired.",i),n.message=s("This playback is using signed URLs and the playback-token has expired. Expired at: {expiredDate}. Current time: {currentDate}.",i).format({expiredDate:new Intl.DateTimeFormat(F.code,H).format(y*1e3),currentDate:new Intl.DateTimeFormat(F.code,H).format(Date.now())}),n.file="403-expired-token.md";break}if(_){r.title=s("Video URL is formatted incorrectly",i),r.message=s("The video\u2019s playback ID does not match the one encoded in the playback-token.",i),n.message=s("The specified playback ID {playbackId} and the playback ID encoded in the playback-token {tokenPlaybackId} do not match.",i).format({playbackId:a,tokenPlaybackId:E}),n.file="403-playback-id-mismatch.md";break}if(h){r.title=s("Video URL is formatted incorrectly",i),r.message=s("The playback-token is formatted with incorrect information.",i),n.message=s("The playback-token has an incorrect aud value: {tokenType}. aud value should be v.",i).format({tokenType:A}),n.file="403-incorrect-aud-value.md";break}n.message=s("403 error trying to access this playback URL. If this is a signed playback ID, the token might not have been generated correctly.",i),n.file="403-malformatted-token.md";break}}break}case xe.MEDIA_ERR_DECODE:{let{message:y}=t;r={title:s("Media Error",i),message:y},n.file="media-decode-error.md";break}case xe.MEDIA_ERR_SRC_NOT_SUPPORTED:{let y=(T=(g=t.data)==null?void 0:g.response)==null?void 0:T.code;if(y>=400&&y<500){t.code=xe.MEDIA_ERR_NETWORK,t.data={response:{code:y}},{dialog:r,devlog:n}=Ae(t,e,a,o);break}r={title:s("Source Not Supported",i),message:t.message},n.file="media-src-not-supported.md";break}default:r={title:s("Error",i),message:t.message};break}return e&&(r={title:s("Your device appears to be offline",i),message:s("Check your internet connection and try reloading this video.",i)}),{dialog:r,devlog:n}}var Ti=Object.values(P),xi=700,Ai=300,We={LG:"large",SM:"small",XS:"extra-small"};function we(t){let e=t.getBoundingClientRect();return e.width<Ai?We.XS:e.width<xi?We.SM:We.LG}var wi={SRC:"src"},c={ENV_KEY:"env-key",DEBUG:"debug",PLAYBACK_ID:"playback-id",METADATA_URL:"metadata-url",PREFER_MSE:"prefer-mse",PLAYER_SOFTWARE_VERSION:"player-software-version",PLAYER_SOFTWARE_NAME:"player-software-name",METADATA_VIDEO_ID:"metadata-video-id",METADATA_VIDEO_TITLE:"metadata-video-title",METADATA_VIEWER_USER_ID:"metadata-viewer-user-id",BEACON_COLLECTION_DOMAIN:"beacon-collection-domain",CUSTOM_DOMAIN:"custom-domain",TYPE:"type",STREAM_TYPE:"stream-type",START_TIME:"start-time"},d={DEFAULT_HIDDEN_CAPTIONS:"default-hidden-captions",PRIMARY_COLOR:"primary-color",SECONDARY_COLOR:"secondary-color",FORWARD_SEEK_OFFSET:"forward-seek-offset",BACKWARD_SEEK_OFFSET:"backward-seek-offset",PLAYBACK_TOKEN:"playback-token",THUMBNAIL_TOKEN:"thumbnail-token",STORYBOARD_TOKEN:"storyboard-token",THUMBNAIL_TIME:"thumbnail-time",AUDIO:"audio",NOHOTKEYS:"nohotkeys"};function Li(t,e){var a,o;return{src:!t.playbackId&&t.src,poster:t.getAttribute("poster"),theme:t.getAttribute("theme"),thumbnailTime:!t.tokens.thumbnail&&t.thumbnailTime,autoplay:t.autoplay,crossOrigin:t.crossOrigin,loop:t.loop,noHotKeys:t.hasAttribute(d.NOHOTKEYS),muted:t.muted,paused:t.paused,playsInline:t.playsInline,preload:t.preload,playbackId:t.playbackId,envKey:t.envKey,debug:t.debug,tokens:t.tokens,beaconCollectionDomain:t.beaconCollectionDomain,metadata:t.metadata,playerSoftwareName:t.playerSoftwareName,playerSoftwareVersion:t.playerSoftwareVersion,startTime:t.startTime,preferMse:t.preferMse,audio:t.audio,streamType:t.streamType,primaryColor:t.primaryColor,secondaryColor:t.secondaryColor,forwardSeekOffset:t.forwardSeekOffset,backwardSeekOffset:t.backwardSeekOffset,defaultHiddenCaptions:t.defaultHiddenCaptions,customDomain:(a=t.getAttribute(c.CUSTOM_DOMAIN))!=null?a:void 0,playerSize:we((o=t.mediaController)!=null?o:t),metadataVideoId:t.getAttribute(c.METADATA_VIDEO_ID),metadataVideoTitle:t.getAttribute(c.METADATA_VIDEO_TITLE),metadataViewerUserId:t.getAttribute(c.METADATA_VIEWER_USER_ID),...e}}var Si=Object.values(c),$i=Object.values(d),Mi=he(),Ci="mux-player",ca={dialog:void 0,isDialogOpen:!1,inLiveWindow:!1},q,me,V,ee,C,te,je,B,le,ae,qe,ce,ua,Se,Oi,$e,Ri,Me,Ii,Ce,Pi,Oe,_i,Re,Di,Le=class extends Be{constructor(){super();k(this,te);k(this,B);k(this,ae);k(this,ce);k(this,Se);k(this,$e);k(this,Me);k(this,Ce);k(this,Oe);k(this,Re);k(this,q,!1);k(this,me,{});k(this,V,!0);k(this,ee,void 0);k(this,C,{...ca,onCloseErrorDialog:()=>f(this,B,le).call(this,{dialog:void 0,isDialogOpen:!1}),onInitFocusDialog:e=>{Pe(this,document.activeElement)||e.preventDefault()},onSeekToLive:()=>Ve(this)});this.attachShadow({mode:"open"}),this.isConnected&&f(this,te,je).call(this)}static get observedAttributes(){var e;return[...(e=Be.observedAttributes)!=null?e:[],...Si,...$i]}get theme(){var e,a;return Array.from((a=(e=this.shadowRoot)==null?void 0:e.children)!=null?a:[]).find(({localName:o})=>o.startsWith("media-theme-"))}get mediaController(){var e,a;return(a=(e=this.theme)==null?void 0:e.shadowRoot)==null?void 0:a.querySelector("media-controller")}connectedCallback(){f(this,ce,ua).call(this),f(this,Se,Oi).call(this)}disconnectedCallback(){f(this,$e,Ri).call(this)}attributeChangedCallback(e,a,o){switch(v(this,q)||f(this,te,je).call(this),super.attributeChangedCallback(e,a,o),[c.PLAYBACK_ID,wi.SRC,d.PLAYBACK_TOKEN].includes(e)&&a!==o&&U(this,C,{...v(this,C),...ca}),f(this,ae,qe).call(this,{[lt(e)]:o}),e){case d.THUMBNAIL_TIME:{o!=null&&this.tokens.thumbnail&&w(s("Use of thumbnail-time with thumbnail-token is currently unsupported. Ignore thumbnail-time.").format({}));break}case d.THUMBNAIL_TOKEN:{let{aud:r}=re(o);o&&r!=="t"&&w(s("The provided thumbnail-token should have audience value 't' instead of '{aud}'.").format({aud:r}));break}case d.STORYBOARD_TOKEN:{let{aud:r}=re(o);o&&r!=="s"&&w(s("The provided storyboard-token should have audience value 's' instead of '{aud}'.").format({aud:r}));break}case c.PLAYBACK_ID:{o.includes("?token")&&D(s("The specificed playback ID {playbackId} contains a token which must be provided via the playback-token attribute.").format({playbackId:o})),this.streamType?this.streamType!=null&&!Ti.includes(this.streamType)&&ge({file:"invalid-stream-type.md",message:s("Invalid stream-type value supplied: `{streamType}`. Please provide stream-type as either: `on-demand`, `live`, `ll-live`, `live:dvr`, or `ll-live:dvr`").format({streamType:this.streamType})}):ge({file:"invalid-stream-type.md",message:String(s("No stream-type value supplied. Defaulting to `on-demand`. Please provide stream-type as either: `on-demand`, `live`, `ll-live`, `live:dvr`, or `ll-live:dvr`"))});break}}}get hasPlayed(){var e,a;return(a=(e=this.mediaController)==null?void 0:e.hasAttribute("media-has-played"))!=null?a:!1}get inLiveWindow(){return v(this,C).inLiveWindow}get hls(){return w("<mux-player>.hls is deprecated, please use ._hls instead"),this._hls}get _hls(){var e;return(e=this.media)==null?void 0:e._hls}get mux(){var e;return(e=this.media)==null?void 0:e.mux}get audio(){return this.hasAttribute(d.AUDIO)}set audio(e){e||this.removeAttribute(d.AUDIO),this.setAttribute(d.AUDIO,"")}get nohotkeys(){return this.hasAttribute(d.NOHOTKEYS)}set nohotkeys(e){e||this.removeAttribute(d.NOHOTKEYS),this.setAttribute(d.NOHOTKEYS,"")}get thumbnailTime(){return K(this.getAttribute(d.THUMBNAIL_TIME))}set thumbnailTime(e){this.setAttribute(d.THUMBNAIL_TIME,`${e}`)}get primaryColor(){var e;return(e=this.getAttribute(d.PRIMARY_COLOR))!=null?e:void 0}set primaryColor(e){this.setAttribute(d.PRIMARY_COLOR,`${e}`)}get secondaryColor(){var e;return(e=this.getAttribute(d.SECONDARY_COLOR))!=null?e:void 0}set secondaryColor(e){this.setAttribute(d.SECONDARY_COLOR,`${e}`)}get forwardSeekOffset(){var e;return(e=K(this.getAttribute(d.FORWARD_SEEK_OFFSET)))!=null?e:10}set forwardSeekOffset(e){this.setAttribute(d.FORWARD_SEEK_OFFSET,`${e}`)}get backwardSeekOffset(){var e;return(e=K(this.getAttribute(d.BACKWARD_SEEK_OFFSET)))!=null?e:10}set backwardSeekOffset(e){this.setAttribute(d.BACKWARD_SEEK_OFFSET,`${e}`)}get defaultHiddenCaptions(){return this.hasAttribute(d.DEFAULT_HIDDEN_CAPTIONS)}get playerSoftwareName(){var e;return(e=this.getAttribute(c.PLAYER_SOFTWARE_NAME))!=null?e:Ci}get playerSoftwareVersion(){var e;return(e=this.getAttribute(c.PLAYER_SOFTWARE_VERSION))!=null?e:Mi}get beaconCollectionDomain(){var e;return(e=this.getAttribute(c.BEACON_COLLECTION_DOMAIN))!=null?e:void 0}set beaconCollectionDomain(e){e!==this.beaconCollectionDomain&&(e?this.setAttribute(c.BEACON_COLLECTION_DOMAIN,e):this.removeAttribute(c.BEACON_COLLECTION_DOMAIN))}get playbackId(){var e;return(e=this.getAttribute(c.PLAYBACK_ID))!=null?e:void 0}set playbackId(e){this.setAttribute(c.PLAYBACK_ID,`${e}`)}get customDomain(){var e;return(e=this.getAttribute(c.CUSTOM_DOMAIN))!=null?e:void 0}set customDomain(e){e!==this.customDomain&&(e?this.setAttribute(c.CUSTOM_DOMAIN,e):this.removeAttribute(c.CUSTOM_DOMAIN))}get envKey(){var e;return(e=de(this,c.ENV_KEY))!=null?e:void 0}set envKey(e){this.setAttribute(c.ENV_KEY,`${e}`)}get debug(){return de(this,c.DEBUG)!=null}set debug(e){e?this.setAttribute(c.DEBUG,""):this.removeAttribute(c.DEBUG)}get streamType(){return de(this,c.STREAM_TYPE)}set streamType(e){this.setAttribute(c.STREAM_TYPE,`${e}`)}get startTime(){return K(de(this,c.START_TIME))}set startTime(e){this.setAttribute(c.START_TIME,`${e}`)}get preferMse(){return de(this,c.PREFER_MSE)!=null}set preferMse(e){e?this.setAttribute(c.PREFER_MSE,""):this.removeAttribute(c.PREFER_MSE)}get metadata(){var e;return(e=this.media)==null?void 0:e.metadata}set metadata(e){if(v(this,q)||f(this,te,je).call(this),!this.media){D("underlying media element missing when trying to set metadata. metadata will not be set.");return}this.media.metadata=e}get tokens(){let e=this.getAttribute(d.PLAYBACK_TOKEN),a=this.getAttribute(d.THUMBNAIL_TOKEN),o=this.getAttribute(d.STORYBOARD_TOKEN);return{...v(this,me),...e!=null?{playback:e}:{},...a!=null?{thumbnail:a}:{},...o!=null?{storyboard:o}:{}}}set tokens(e){U(this,me,e!=null?e:{})}get playbackToken(){var e;return(e=this.getAttribute(d.PLAYBACK_TOKEN))!=null?e:void 0}set playbackToken(e){this.setAttribute(d.PLAYBACK_TOKEN,`${e}`)}get thumbnailToken(){var e;return(e=this.getAttribute(d.THUMBNAIL_TOKEN))!=null?e:void 0}set thumbnailToken(e){this.setAttribute(d.THUMBNAIL_TOKEN,`${e}`)}get storyboardToken(){var e;return(e=this.getAttribute(d.STORYBOARD_TOKEN))!=null?e:void 0}set storyboardToken(e){this.setAttribute(d.STORYBOARD_TOKEN,`${e}`)}addTextTrack(e,a,o,i){var n;let r=(n=this.media)==null?void 0:n.nativeEl;if(!!r)return ki(r,e,a,o,i)}removeTextTrack(e){var o;let a=(o=this.media)==null?void 0:o.nativeEl;if(!!a)return Ei(a,e)}get textTracks(){var e;return(e=this.media)==null?void 0:e.textTracks}};q=new WeakMap,me=new WeakMap,V=new WeakMap,ee=new WeakMap,C=new WeakMap,te=new WeakSet,je=function(){var e,a,o;if(!v(this,q)){U(this,q,!0),f(this,B,le).call(this,{playerSize:we(this)});try{if(customElements.upgrade(this.theme),!(this.theme instanceof HTMLElement))throw""}catch{D(`<${(e=this.theme)==null?void 0:e.localName}> failed to upgrade!`)}try{if(customElements.upgrade(this.media),!(this.media instanceof vi))throw""}catch{D("<mux-video> failed to upgrade!")}try{if(customElements.upgrade(this.mediaController),!(this.mediaController instanceof yi))throw""}catch{D("<media-controller> failed to upgrade!")}ht(this),f(this,Ce,Pi).call(this),f(this,Oe,_i).call(this),f(this,Me,Ii).call(this),U(this,V,(o=(a=this.mediaController)==null?void 0:a.hasAttribute("user-inactive"))!=null?o:!0),f(this,Re,Di).call(this)}},B=new WeakSet,le=function(e){Object.assign(v(this,C),e),f(this,ae,qe).call(this)},ae=new WeakSet,qe=function(e={}){ve(ma(Li(this,{...v(this,C),...e})),this.shadowRoot)},ce=new WeakSet,ua=function(){var e,a;v(this,C).playerSize!=we((e=this.mediaController)!=null?e:this)&&f(this,B,le).call(this,{playerSize:we((a=this.mediaController)!=null?a:this)})},Se=new WeakSet,Oi=function(){var e;U(this,ee,new ResizeObserver(()=>f(this,ce,ua).call(this))),v(this,ee).observe((e=this.mediaController)!=null?e:this)},$e=new WeakSet,Ri=function(){var e;(e=v(this,ee))==null||e.disconnect()},Me=new WeakSet,Ii=function(){var a,o,i,r,n;(a=this.mediaController)==null||a.addEventListener("mediaplayrequest",m=>{var g;((g=m.target)==null?void 0:g.localName)==="media-play-button"&&this.streamType&&[P.LIVE,P.LL_LIVE,P.DVR,P.LL_DVR].includes(this.streamType)&&this.hasPlayed&&Ve(this)});let e=()=>{let m=ut(this),g=v(this,C).inLiveWindow;m!==g&&(f(this,B,le).call(this,{inLiveWindow:m}),this.dispatchEvent(new CustomEvent("inlivewindowchange",{composed:!0,bubbles:!0,detail:this.inLiveWindow})))};(o=this.media)==null||o.addEventListener("progress",e),(i=this.media)==null||i.addEventListener("waiting",e),(r=this.media)==null||r.addEventListener("timeupdate",e),(n=this.media)==null||n.addEventListener("emptied",e)},Ce=new WeakSet,Pi=function(){var a;let e=o=>{let{detail:i}=o;if(i instanceof ze||(i=new ze(i.message,i.code,i.fatal)),!(i==null?void 0:i.fatal)){w(i),i.data&&w(`${i.name} data:`,i.data);return}let{dialog:r,devlog:n}=Ae(i,!window.navigator.onLine,this.playbackId,this.playbackToken);n.message&&ge(n),D(i),i.data&&D(`${i.name} data:`,i.data),f(this,B,le).call(this,{isDialogOpen:!0,dialog:r})};this.addEventListener("error",e),this.media&&(this.media.errorTranslator=(o={})=>{var r,n,m;if(!((r=this.media)==null?void 0:r.error))return o;let{devlog:i}=Ae((n=this.media)==null?void 0:n.error,!window.navigator.onLine,this.playbackId,this.playbackToken,!1);return{player_error_code:(m=this.media)==null?void 0:m.error.code,player_error_message:i.message?String(i.message):o.player_error_message}}),(a=this.media)==null||a.addEventListener("error",o=>{var r,n;let{detail:i}=o;if(!i){let{message:m,code:g}=(n=(r=this.media)==null?void 0:r.error)!=null?n:{};i=new ze(m,g)}!(i==null?void 0:i.fatal)||this.dispatchEvent(new CustomEvent("error",{detail:i}))})},Oe=new WeakSet,_i=function(){var a,o,i,r;let e=()=>f(this,ae,qe).call(this);(o=(a=this.media)==null?void 0:a.textTracks)==null||o.addEventListener("addtrack",e),(r=(i=this.media)==null?void 0:i.textTracks)==null||r.addEventListener("removetrack",e)},Re=new WeakSet,Di=function(){var y,A;let e=this.mediaController,a=/.*Version\/.*Safari\/.*/.test(navigator.userAgent);if(/.*iPhone.*/.test(navigator.userAgent))return;let i,r=new WeakMap,n=()=>this.streamType&&[P.LIVE,P.LL_LIVE].includes(this.streamType)&&!this.secondaryColor&&this.offsetWidth>=800,m=(E,O)=>{if(n())return;Array.from(E&&E.activeCues||[]).forEach(h=>{if(!(!h.snapToLines||h.line<-5||h.line>=0&&h.line<10))if(!O||this.paused){let H=h.text.split(`
`).length,ie=a?-2:-3;this.streamType&&[P.LIVE,P.LL_LIVE].includes(this.streamType)&&(ie=a?-1:-2);let oe=ie-H;if(h.line===oe)return;r.has(h)||r.set(h,h.line),h.line=0,h.line=oe}else setTimeout(()=>{h.line=r.get(h)||"auto"},500)})},g=()=>{var E;m(i,(E=e==null?void 0:e.hasAttribute("user-inactive"))!=null?E:!1)},T=()=>{var _;let O=Array.from(((_=e==null?void 0:e.media)==null?void 0:_.textTracks)||[]).filter(h=>["subtitles","captions"].includes(h.kind)&&h.mode==="showing")[0];O!==i&&(i==null||i.removeEventListener("cuechange",g)),i=O,i==null||i.addEventListener("cuechange",g),m(i,v(this,V))};T(),(y=e==null?void 0:e.media)==null||y.textTracks.addEventListener("change",T),(A=e==null?void 0:e.media)==null||A.textTracks.addEventListener("addtrack",T),e==null||e.addEventListener("userinactivechange",()=>{let E=e==null?void 0:e.hasAttribute("user-inactive");v(this,V)!==E&&(U(this,V,E),m(i,v(this,V)))})};function de(t,e){return t.media?t.media.getAttribute(e):t.getAttribute(e)}globalThis.customElements.get("mux-player")||(globalThis.customElements.define("mux-player",Le),globalThis.MuxPlayerElement=Le);var vr=Le;export{ze as MediaError,vr as default,de as getVideoAttribute};
